const config = {
    api: (process.env.REACT_APP_API_URL == "https://tapi.tripvaletincentives.com/") ? "https://tapi.tripvaletincentives.com/" : "https://apistaging.tripvalet.com/",
    arriviaDomain: "membersprifetravelclub.saveonuat.com",
    arriviaRedirectUrl: " https://membersprifetravelclub.saveonuat.com/vacationclub/logincheck.aspx?Token="
}
export default config
